<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-4">
        <h2>QR Obras</h2>
        <h3>Admin - Status</h3>
    </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
        <div class="col-lg-12">
            <div class="ibox float-e-margins">
                <div class="ibox-content box-content">

                    <div class="info-page">
                        <h3>Admin - Status - {{ actionLabel }} </h3>
                    </div>

                    <form [formGroup]="form" (ngSubmit)="salvar()">
                        <div class="form-group row m-b">
                            <div class="col-sm-4">
                                <label class="col-sm-12 pb-1">Nome: </label>
                                <input type="text" id="name" class="form-control" formControlName="name" required />
                                <app-field-message [field]="fieldMessageRequired('name')"
                                    [erros]="fieldErros('name')"></app-field-message>
                            </div>
                        </div>

                        <div class="hr-line-dashed"></div>
                        <div class="form-group row d-flex justify-content-end">
                            <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                                <button class="btn btn-danger m-r-xxl" *ngIf="this.entity?.id" (click)="confirmExcluir()" type="button">Excluir</button>      
                                <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                                <button class="btn btn-primary" type="submit">Salvar</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<app-loading [loader]="isLoading"></app-loading>